
import React from 'react';
import { ActivityLogEntry, ActivityLogTargetType } from '../types';

// Icons for different log target types
const TicketIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 6.75h-9" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5h-9" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 14.25h-9" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 3.75H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H15M9 3.75L12 3m0 0l3-3.75M12 3v1.5" />
  </svg>
);
const UserGroupIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-3.741-5.243M15 15.75a3 3 0 01-3-3M15 15.75a3 3 0 00-3-3m-3.75 3.75a3 3 0 01-3-3M15 15.75a3 3 0 003 3M12 12.75v-1.5m0 1.5H9.75m2.25 0a2.25 2.25 0 012.25 2.25M12 12.75v-1.5m0 1.5a2.25 2.25 0 00-2.25 2.25M12 12.75V9.75m0 3H9.75M3.75 21A3.75 3.75 0 017.5 17.25m5.25 0a3.75 3.75 0 013.75 3.75M16.5 21a3.75 3.75 0 003.75-3.75m0 0V17.25m0 0A3.75 3.75 0 0016.5 13.5m-5.25 0A3.75 3.75 0 007.5 13.5m0 0V17.25m0 0A3.75 3.75 0 003.75 21" />
  </svg>
);
const CogIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l-1.41-.513M3 10.5h18M4.5 4.5l.47.187m14.554 9.626l-.47.187M9.75 21a8.25 8.25 0 0010.607-6.75M9.75 3a8.25 8.25 0 0110.607 6.75" />
  </svg>
);
const ArchiveBoxIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10.5 11.25h3M12 15h.008" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 7.5h16.5M16.5 7.5V5.625c0-1.036-.84-1.875-1.875-1.875h-5.25C8.34 3.75 7.5 4.59 7.5 5.625V7.5" />
  </svg>
);
const UserCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const CurrencyDollarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 11.219 12.768 11 12 11c-.768 0-1.536.219-2.121.782l-.879.659M7.5 14.25l6-6M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);
const CreditCardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
    </svg>
);
const DocumentMagnifyingGlassIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-2 text-[var(--color-primary)]" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m5.231 13.481L15 17.25m-4.5 4.5L6.75 17.25M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
  </svg>
);


interface AdminActivityLogPageProps {
  logEntries: ActivityLogEntry[];
}

const getTargetIcon = (targetType?: ActivityLogTargetType) => {
  const iconClass = "w-5 h-5 text-slate-500";
  switch (targetType) {
    case ActivityLogTargetType.TICKET: return <TicketIcon className={iconClass} />;
    case ActivityLogTargetType.CUSTOMER: return <UserGroupIcon className={iconClass} />;
    case ActivityLogTargetType.SYSTEM: return <CogIcon className={iconClass} />;
    case ActivityLogTargetType.SETTINGS: return <CogIcon className={iconClass} />; // Using CogIcon also for Settings
    case ActivityLogTargetType.INVENTORY: return <ArchiveBoxIcon className={iconClass} />;
    case ActivityLogTargetType.USER: return <UserCircleIcon className={iconClass} />;
    case ActivityLogTargetType.BUYBACK: return <CurrencyDollarIcon className={iconClass} />;
    case ActivityLogTargetType.PAYMENT: return <CreditCardIcon className={iconClass} />;
    default: return <CogIcon className={iconClass} />; // Default icon
  }
};

export const AdminActivityLogPage: React.FC<AdminActivityLogPageProps> = ({ logEntries }) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString('en-US', {
      dateStyle: 'short',
      timeStyle: 'medium',
    });
  };

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <div className="flex items-center mb-1">
          <DocumentMagnifyingGlassIcon />
          <h1 className="text-2xl font-bold text-[var(--color-primary)]">Application Activity Log</h1>
        </div>
        <p className="text-sm text-slate-600">Track key events and changes within the system. Logs are capped at the latest 200 entries.</p>
      </div>

      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        {logEntries.length === 0 ? (
          <p className="p-8 text-center text-slate-500">No activity logs recorded yet.</p>
        ) : (
          <ul className="divide-y divide-slate-200 max-h-[calc(100vh-250px)] overflow-y-auto">
            {logEntries.map((log) => (
              <li key={log.id} className="p-4 hover:bg-slate-50 transition-colors">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0 pt-0.5">
                    {getTargetIcon(log.targetType)}
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-center">
                      <p className="text-sm font-medium text-slate-800">
                        {log.action}
                        {log.targetId && <span className="text-slate-500 font-normal"> ({log.targetType}: {log.targetId})</span>}
                      </p>
                      <p className="text-xs text-slate-500 whitespace-nowrap">{formatDate(log.timestamp)}</p>
                    </div>
                    <p className="text-sm text-slate-600">
                      <span className="font-semibold">{log.user}</span>
                      {log.details && <span className="text-slate-500 italic"> - {log.details}</span>}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
